import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Input, InputGroup, InputGroupText } from 'reactstrap'
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks'
import { setNewModal } from '../../../../../redux/reducers/messenger/messengerSlice'
import SimpleModal from '../../../../../shared/modal/SimpleModal'
import { useDebounce } from '../../../../../utils/useDebounce'
import useMediaQuery from '../../../../../utils/useMediaQuery'
import Contacts from '../chat/Contacts'
import { RiLoader2Line } from 'react-icons/ri'

const Chats = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isMobile = useMediaQuery('(max-width: 800px)')
  const { newModal } = useAppSelector((state) => state.messenger)
  const searchInputRef = useRef<HTMLInputElement>(null)
  const closeModal = () => dispatch(setNewModal(0))
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [localSearchTerm, setLocalSearchTerm] = useState('')
  const debouncedLocalSearch = useDebounce(localSearchTerm, 500)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchTerm(e.target.value)
  }

  const onLoading = (status: boolean) => {
    setIsLoading(status)
  }

  useEffect(() => {
    if(!newModal[0]) {
      setLocalSearchTerm('');
    }
  }, [newModal]);

  // On mobile the popup is full-screen. The host page's bottom footer lives
  // outside our shadow DOM, so a high z-index alone can't cover it — we have to
  // lift the whole widget host element above it while the popup is open.
  useEffect(() => {
    if (typeof document === 'undefined') return
    const host = document.querySelector('dubai-brokers-chat')
    if (!host) return

    if (newModal[0] && isMobile) {
      host.classList.add('chat-modal-open')
    } else {
      host.classList.remove('chat-modal-open')
    }

    return () => host.classList.remove('chat-modal-open')
  }, [newModal, isMobile])

  return (
    <SimpleModal
      isOpen={newModal[0]}
      onClose={closeModal}
      title={t('start_new_chat')}
      className="fade show add-popup msg-chat-modal"
      centered={!isMobile}
      fullscreen={isMobile}
      onOpened={() => searchInputRef.current?.focus()}
    >
      <div className="chat-msg-search">
        <InputGroup>
          <Input
            innerRef={searchInputRef}
            type="text"
            placeholder={t('search')}
            value={localSearchTerm}
            onChange={handleSearchChange}
          />
          <div className="input-group-append">
            {isLoading ? (
              <InputGroupText>
                <RiLoader2Line style={{marginRight:0}} className="btn-icon animate-spin" />
              </InputGroupText>
            ) : (
              <InputGroupText>@</InputGroupText>
            )}
          </div>
        </InputGroup>
      </div>
      <Contacts onLoading={onLoading} onChatSelect={closeModal} localSearch={debouncedLocalSearch} />
    </SimpleModal>
  )
}

export default Chats
